import { render, staticRenderFns } from "./default_content_modal.vue?vue&type=template&id=67509212&"
import script from "./default_content_modal.vue?vue&type=script&lang=js&"
export * from "./default_content_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports